import { Box, BoxProps, Typography, TypographyProps } from '@mui/material';
import { useTheme } from '@mui/styles';
import { styled } from '@mui/material/styles';

import SunnysideGrid from '../../../components_sunnyside/grid';
import Image from '../../../components_sunnyside/image';
import HrishikeshBelani from '../../../../public/img/sunnyside/advisors/hirshikesh_belani.webp';
import KateBonham from '../../../../public/img/sunnyside/advisors/kate_bonham.webp';
import NirEyal from '../../../../public/img/sunnyside/advisors/nir_eyal.webp';
import AdiJaffe from '../../../../public/img/sunnyside/advisors/adi_jaffe.webp';
import { colors } from '../../../styles/_colors';

interface HomeScience2Props {
    backgroundColor?: string,
}

export default function HomeScience2(props: HomeScience2Props): JSX.Element {
    const { backgroundColor } = props;
    const theme = useTheme();
    const AdvisorContainer = styled(Box)<BoxProps>(({ theme }) => ({
        display: 'flex',
        width: '100%',
        [theme.breakpoints.down(1250)]: {
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
        },
        [theme.breakpoints.up(1250)]: {
            flexDirection: 'row',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
        },
    }));
    const AdvisorBox = styled(Box)<BoxProps>(({ theme }) => ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        [theme.breakpoints.down('sm')]: {
            paddingBottom: '2.5rem'
        },
    }));
    const AdvisorName = styled(Typography)<TypographyProps>(({ theme }) => ({
        fontFamily: 'Recoleta Medium',
        color: colors.brown,
        fontStyle: 'normal',
        fontWeight: 400,
        textAlign: 'center',
        letterSpacing: '-0.01em',
        paddingTop: '1rem',
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.375rem',
            lineHeight: '2.5rem',
        },
        [theme.breakpoints.up('sm')]: {
            fontSize: '1.375rem',
            lineHeight: '2.5rem',
        },
    }));
    const AdvisorDescriptor = styled(Typography)<TypographyProps>(({ theme }) => ({
        fontFamily: 'Good Sans Regular',
        color: colors.dark_gold,
        fontWeight: 400,
        textAlign: 'center',
        letterSpacing: '-0.01em',
        width: '15rem',
        [theme.breakpoints.down('sm')]: {
            fontSize: '1rem',
            lineHeight: '1.375rem',
        },
        [theme.breakpoints.up('sm')]: {
            fontSize: '1rem',
            lineHeight: '1.375rem',
        },
    }));
    const YellowBox = styled(Box)<BoxProps>(({ theme }) => ({
        height: '0.5rem',
        width: '5rem',
        background: colors.sunny,
        margin: '2rem 0rem'
    }));
    const Quote = styled(Typography)<TypographyProps>(({ theme }) => ({
        fontFamily: 'Recoleta Medium',
        color: '#333333',
        fontWeight: 400,
        textAlign: 'center',
        letterSpacing: '-0.01em',
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.375rem',
            lineHeight: '2.1875rem',
        },
        [theme.breakpoints.up('sm')]: {
            fontSize: '2.375rem',
            lineHeight: '3.4375rem',
        },
    }));
    const QuoteAuthor = styled(Typography)<TypographyProps>(({ theme }) => ({
        fontFamily: 'Good Sans Regular',
        color: colors.brown,
        fontWeight: 400,
        textAlign: 'center',
        letterSpacing: '-0.01em',
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.1875rem',
            lineHeight: '3.4375rem',
        },
        [theme.breakpoints.up('sm')]: {
            fontSize: '1.1875rem',
            lineHeight: '3.4375rem',
        },
    }));
    return (
        <SunnysideGrid 
            maxwidthwrapper
            background={backgroundColor || colors.beige}
        >
            <Box display='flex' 
                flexDirection='column' 
                width='100%' 
                justifyContent='center' 
                alignItems='center'>
                <Typography 
                    variant='h2'
                    textAlign='center'>
                    Backed by science
                </Typography>
                <Typography 
                    variant='body2'
                    textAlign='center'
                    padding="1rem 0rem 2.75rem 0rem"
                    sx={{
                        [theme.breakpoints.down('md')]: {
                            width: '100%'
                        },
                        [theme.breakpoints.up('md')]: {
                            width: '50rem'
                        },
                    }}>
                    Sunnyside utilizes proven behavior-change techniques to help 
                    you reach your goals, and it&apos;s all reviewed by our team 
                    of experts.
                </Typography>
                <AdvisorContainer>
                    <AdvisorBox>
                        <Image src={HrishikeshBelani}
                            width={259}
                            height={259}
                            alt='hrishikesh belani image' 
                            objectFit='cover'/>
                        <AdvisorName variant='h3'>
                            Dr. Hrishikesh Belani
                        </AdvisorName>
                        <AdvisorDescriptor>
                            Associate Medical Director of the South Los Angeles Health Center Group
                        </AdvisorDescriptor>
                    </AdvisorBox>
                    <AdvisorBox>
                        <Image src={KateBonham}
                            width={259}
                            height={259}
                            alt='hrishikesh belani image' 
                            objectFit='cover'/>
                        <AdvisorName variant='h3'>
                            Kate Bonham
                        </AdvisorName>
                        <AdvisorDescriptor>
                            MS, LPCC, LADC - Mental Health and Chemical Health Specialist
                        </AdvisorDescriptor>
                    </AdvisorBox>
                    <AdvisorBox>
                        <Image src={NirEyal}
                            width={259}
                            height={259}
                            alt='hrishikesh belani image' 
                            objectFit='cover'/>
                        <AdvisorName variant='h3'>
                            Nir Eyal
                        </AdvisorName>
                        <AdvisorDescriptor>
                            Habit expert, author of Hooked and Indistractable
                        </AdvisorDescriptor>
                    </AdvisorBox>
                    <AdvisorBox>
                        <Image src={AdiJaffe}
                            width={259}
                            height={259}
                            alt='hrishikesh belani image' 
                            objectFit='cover'/>
                        <AdvisorName variant='h3'>
                            Adi Jaffe
                        </AdvisorName>
                        <AdvisorDescriptor>
                            Mental health &amp; addiction expert, Author of The Abstinence Myth
                        </AdvisorDescriptor>
                    </AdvisorBox>
                </AdvisorContainer>
                <YellowBox />
                <Quote>
                    &quot;As a doctor, I&apos;ve seen firsthand the difference that a better relationship with alcohol can make in a person&apos;s overall health outcomes, which is why I recommend Sunnyside to my patients.&quot;
                </Quote>
                <QuoteAuthor>
                    Dr. Hrishikesh Belani
                </QuoteAuthor>
            </Box>
        </SunnysideGrid>
    );
}